import { AmplitudeAnalyticsService } from './amplitude-analytics.service';
import { AnalyticsService } from './analytics.service';

export const services = [AnalyticsService, AmplitudeAnalyticsService];

export * from './analytics.service';
export * from './amplitude-analytics.service';
